// extracted by mini-css-extract-plugin
export var chip = "_mn-0";
export var icon = "_mn-1";
export var remove = "_mn-2";
export var removeIcon = "_mn-3";